
function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}

function $parcel$defineInteropFlag(a) {
  Object.defineProperty(a, '__esModule', {value: true, configurable: true});
}

function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

      var $parcel$global = globalThis;
    var parcelRequire = $parcel$global["parcelRequire49d7"];
var parcelRegister = parcelRequire.register;
parcelRegister("61Hor", function(module, exports) {

$parcel$defineInteropFlag(module.exports);
$parcel$export(module.exports, "Trackers", () => $0f6dacad8ab4bf3e$export$a2c5350cd99575c4);
$parcel$export(module.exports, "default", () => $0f6dacad8ab4bf3e$export$2e2bcd8739ae039);

var $eJOHy = parcelRequire("eJOHy");

var $1SiuD = parcelRequire("1SiuD");

var $jMOtB = parcelRequire("jMOtB");

var $65dm0 = parcelRequire("65dm0");

var $c0WCG = parcelRequire("c0WCG");
const $0f6dacad8ab4bf3e$export$a2c5350cd99575c4 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $c0WCG.SpaResourceMetricsController), null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $jMOtB.default), null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $1SiuD.default), null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $65dm0.default), null));
var $0f6dacad8ab4bf3e$export$2e2bcd8739ae039 = $0f6dacad8ab4bf3e$export$a2c5350cd99575c4;

});
parcelRegister("1SiuD", function(module, exports) {
$parcel$export(module.exports, "default", () => $aa1443436b007cdd$export$2e2bcd8739ae039);

var $eJOHy = parcelRequire("eJOHy");

var $6NtES = parcelRequire("6NtES");

var $aYncF = parcelRequire("aYncF");

var $h47gY = parcelRequire("h47gY");

var $kRgKj = parcelRequire("kRgKj");
var $iFaP4 = parcelRequire("iFaP4");

const $aa1443436b007cdd$var$FireDevopsTargetingEvents = ()=>{
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $iFaP4.useAnalyticsEvents)();
    // This tenant context value is set only when the user signs up for a devops instance.
    const isDevopsSite = (0, $aYncF.getTenantContext_DEPRECATED_DO_NOT_USE)().isDevopsProjectCreationScenario;
    (0, $eJOHy.useEffect)(()=>{
        if (isDevopsSite) (0, $kRgKj.fireOperationalAnalytics)(createAnalyticsEvent({}), 'devopsSite visited');
    }, [
        createAnalyticsEvent,
        isDevopsSite
    ]);
    return null;
};
const $aa1443436b007cdd$var$WithAnalyticsFireDevopsTargetingEvents = (0, $6NtES.default)()($aa1443436b007cdd$var$FireDevopsTargetingEvents);
const $aa1443436b007cdd$var$SafeWithAnalyticsFireDevopsTargetingEvents = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $h47gY.default), {
        id: (0, $a1fdd1fba3caf409$export$8be180ec26319f9f),
        packageName: (0, $a1fdd1fba3caf409$export$b8b9d90f9e5bd72b)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($aa1443436b007cdd$var$WithAnalyticsFireDevopsTargetingEvents, null));
var $aa1443436b007cdd$export$2e2bcd8739ae039 = $aa1443436b007cdd$var$SafeWithAnalyticsFireDevopsTargetingEvents;

});
const $a1fdd1fba3caf409$export$b8b9d90f9e5bd72b = 'jiraSpaAppsDevopsFireTargetingEvents';
const $a1fdd1fba3caf409$export$8be180ec26319f9f = 'devopsFireTargetingEvents';


parcelRegister("jMOtB", function(module, exports) {
$parcel$export(module.exports, "default", () => $52f8f7d524a246da$export$2e2bcd8739ae039);

var $d8gKU = parcelRequire("d8gKU");

var $iqsE8 = parcelRequire("iqsE8");

var $aYncF = parcelRequire("aYncF");

var $2QUmO = parcelRequire("2QUmO");

var $1oV6E = parcelRequire("1oV6E");

var $cVyOA = parcelRequire("cVyOA");

var $4K3SF = parcelRequire("4K3SF");
var $52f8f7d524a246da$export$2e2bcd8739ae039 = (0, $2QUmO.default)((0, $1oV6E.default), {
    onJswJsdBundleCheck: ()=>(0, $d8gKU.default)() && (0, $iqsE8.default)(),
    onJswConfluenceBundleCheck: ()=>(0, $cVyOA.default)() && (0, $4K3SF.default)(),
    onGetFirstActivationDate: ()=>(0, $aYncF.getFirstActivationDate)()
});

});
parcelRegister("d8gKU", function(module, exports) {
$parcel$export(module.exports, "default", () => $9529b0fdd0e9995f$export$2e2bcd8739ae039);

var $aYncF = parcelRequire("aYncF");
const $9529b0fdd0e9995f$var$hasJswJsd = ()=>{
    const products = (0, $aYncF.getLicensedProducts)();
    const { JIRA_SOFTWARE: JIRA_SOFTWARE, JIRA_SERVICEDESK: JIRA_SERVICEDESK } = (0, $aYncF.LICENSED_PRODUCTS);
    return products[JIRA_SOFTWARE] && products[JIRA_SERVICEDESK];
};
var $9529b0fdd0e9995f$export$2e2bcd8739ae039 = $9529b0fdd0e9995f$var$hasJswJsd;

});

parcelRegister("iqsE8", function(module, exports) {
$parcel$export(module.exports, "default", () => $b9d41d1dddb767f9$export$2e2bcd8739ae039);

var $aYncF = parcelRequire("aYncF");
const $b9d41d1dddb767f9$var$isJswJsdBundle = ()=>{
    const { JIRA_SOFTWARE: JIRA_SOFTWARE, JIRA_SERVICEDESK: JIRA_SERVICEDESK } = (0, $aYncF.LICENSED_PRODUCTS);
    const initialProductList = (0, $aYncF.getInitialProductList)();
    return initialProductList !== undefined && initialProductList.startsWith(`${JIRA_SOFTWARE}.ondemand,${JIRA_SERVICEDESK}.ondemand`);
};
var $b9d41d1dddb767f9$export$2e2bcd8739ae039 = $b9d41d1dddb767f9$var$isJswJsdBundle;

});

parcelRegister("1oV6E", function(module, exports) {
$parcel$export(module.exports, "default", () => $df1e088c869d5398$export$2e2bcd8739ae039);

var $eJOHy = parcelRequire("eJOHy");

var $6NtES = parcelRequire("6NtES");

var $kRgKj = parcelRequire("kRgKj");
const $df1e088c869d5398$var$SEVEN_DAYS_IN_MS = 604800000;
class $df1e088c869d5398$export$7b4bc8546790dc76 extends (0, $eJOHy.Component) {
    static{
        this.displayName = 'FireEngagementTargetingEvents';
    }
    componentDidMount() {
        const { onJswConfluenceBundleCheck: onJswConfluenceBundleCheck, onJswJsdBundleCheck: onJswJsdBundleCheck, createAnalyticsEvent: createAnalyticsEvent, onGetFirstActivationDate: onGetFirstActivationDate } = this.props;
        const isJswConfluenceBundle = onJswConfluenceBundleCheck();
        const isJswJsdBundle = onJswJsdBundleCheck();
        const firstActivationDate = onGetFirstActivationDate();
        const currentTime = Date.now();
        const timeSinceInstanceActivation = firstActivationDate !== null ? currentTime - firstActivationDate : null;
        if (timeSinceInstanceActivation !== null && timeSinceInstanceActivation > 0 && timeSinceInstanceActivation < $df1e088c869d5398$var$SEVEN_DAYS_IN_MS) {
            if (isJswConfluenceBundle) (0, $kRgKj.fireOperationalAnalytics)(createAnalyticsEvent({}), 'appswitcherSpotlight targeting');
            if (isJswJsdBundle) (0, $kRgKj.fireOperationalAnalytics)(createAnalyticsEvent({}), 'appswitcherjsdspotlight targeting');
        }
    }
    render() {
        return null;
    }
}
var $df1e088c869d5398$export$2e2bcd8739ae039 = (0, $6NtES.default)()($df1e088c869d5398$export$7b4bc8546790dc76);

});

parcelRegister("cVyOA", function(module, exports) {
$parcel$export(module.exports, "default", () => $1059a40524a95b69$export$2e2bcd8739ae039);

var $aYncF = parcelRequire("aYncF");
const $1059a40524a95b69$var$hasJswConfluence = ()=>{
    const products = (0, $aYncF.getLicensedProducts)();
    const { JIRA_SOFTWARE: JIRA_SOFTWARE, CONFLUENCE: CONFLUENCE } = (0, $aYncF.LICENSED_PRODUCTS);
    return products[JIRA_SOFTWARE] && products[CONFLUENCE];
};
var $1059a40524a95b69$export$2e2bcd8739ae039 = $1059a40524a95b69$var$hasJswConfluence;

});

parcelRegister("4K3SF", function(module, exports) {
$parcel$export(module.exports, "default", () => $b571f897981526fd$export$2e2bcd8739ae039);

var $aYncF = parcelRequire("aYncF");
const $b571f897981526fd$var$isJswConfluenceBundle = ()=>{
    const { JIRA_SOFTWARE: JIRA_SOFTWARE, CONFLUENCE: CONFLUENCE } = (0, $aYncF.LICENSED_PRODUCTS);
    const initialProductList = (0, $aYncF.getInitialProductList)();
    return initialProductList !== undefined && initialProductList.startsWith(`${JIRA_SOFTWARE}.ondemand,${CONFLUENCE}.ondemand`);
};
var $b571f897981526fd$export$2e2bcd8739ae039 = $b571f897981526fd$var$isJswConfluenceBundle;

});


parcelRegister("65dm0", function(module, exports) {
$parcel$export(module.exports, "default", () => $b3fcb9365b755f03$export$2e2bcd8739ae039);

var $eJOHy = parcelRequire("eJOHy");

var $kRgKj = parcelRequire("kRgKj");
var $iFaP4 = parcelRequire("iFaP4");
const $b3fcb9365b755f03$var$LegacyIssueCreateTrackers = ()=>{
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $iFaP4.useAnalyticsEvents)();
    const trackLegacyIssueCreate = (0, $eJOHy.useCallback)((event)=>{
        if (!(event instanceof CustomEvent)) return;
        const payload = event.detail;
        const trackEvent = createAnalyticsEvent({});
        (0, $kRgKj.fireTrackAnalytics)(trackEvent, 'issueCreated inProductSurvey', payload.objectId, {
            ...payload.attributes
        });
    }, [
        createAnalyticsEvent
    ]);
    (0, $eJOHy.useEffect)(()=>{
        // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
        document.addEventListener('legacy_legacyIssueCreated', trackLegacyIssueCreate);
        // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
        return ()=>document.removeEventListener('legacy_legacyIssueCreated', trackLegacyIssueCreate);
    }, [
        createAnalyticsEvent,
        trackLegacyIssueCreate
    ]);
    return null;
};
var $b3fcb9365b755f03$export$2e2bcd8739ae039 = $b3fcb9365b755f03$var$LegacyIssueCreateTrackers;

});

parcelRegister("c0WCG", function(module, exports) {
$parcel$export(module.exports, "SpaResourceMetricsController", () => $4b8251d22820126b$export$b5bbbe33c7801196);

var $eJOHy = parcelRequire("eJOHy");

var $jOCpp = parcelRequire("jOCpp");

var $9pTd3 = parcelRequire("9pTd3");

var $iFaP4 = parcelRequire("iFaP4");

var $eSnSE = parcelRequire("eSnSE");

var $4cTDP = parcelRequire("4cTDP");

var $hWeHP = parcelRequire("hWeHP");

var $kRgKj = parcelRequire("kRgKj");

var $cJYBV = parcelRequire("cJYBV");

var $912hm = parcelRequire("912hm");

var $3lhVL = parcelRequire("3lhVL");

var $kfvK2 = parcelRequire("kfvK2");
var $eJrcF = parcelRequire("eJrcF");

var $gNSxk = parcelRequire("gNSxk");
const $4b8251d22820126b$var$defaultMetrics = {
    type: null,
    duration: null,
    end: null,
    isCacheHit: null,
    start: 0
};
const $4b8251d22820126b$var$canSendMetrics = ({ duration: duration, end: end, isCacheHit: isCacheHit, start: start })=>isCacheHit !== $4b8251d22820126b$var$defaultMetrics.isCacheHit && duration !== $4b8251d22820126b$var$defaultMetrics.duration && start !== $4b8251d22820126b$var$defaultMetrics.start && end !== $4b8251d22820126b$var$defaultMetrics.end;
const $4b8251d22820126b$var$isCachedResource = (slice, invocationTimestamp)=>!slice.loading && (slice.expiresAt ?? 0) > invocationTimestamp;
const $4b8251d22820126b$var$SAMPLING_RATE = 10;
const $4b8251d22820126b$var$ResourceMetricTracker = ({ resource: resource, route: currentRoute, currentMatch: currentMatch, isInitialRender: isInitialRender })=>{
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $iFaP4.useAnalyticsEvents)();
    const { setResourceMetrics: setResourceMetrics } = (0, $912hm.useSpaStateActions)();
    const [metrics, setMetrics] = (0, $eJOHy.useState)($4b8251d22820126b$var$defaultMetrics);
    const isSentRef = (0, $eJOHy.useRef)(false);
    const slice = (0, $eJrcF.useResource)(resource);
    (0, $eJOHy.useEffect)(()=>// clear metrics on route change
        ()=>{
            setMetrics({
                ...$4b8251d22820126b$var$defaultMetrics
            });
            isSentRef.current = false;
        }, [
        currentRoute
    ]);
    // watch the resource and update metrics
    (0, $eJOHy.useEffect)(()=>{
        if (slice.expiresAt === null || isSentRef.current) // don't record metrics until the slice has an expiry set
        return;
        const invocationTimestamp = Date.now();
        if (metrics.isCacheHit === null && $4b8251d22820126b$var$isCachedResource(slice, invocationTimestamp)) {
            // cached resource
            setMetrics((state)=>({
                    ...state,
                    duration: 0,
                    end: invocationTimestamp,
                    isCacheHit: true,
                    start: invocationTimestamp,
                    type: resource.type
                }));
            return;
        }
        if (slice.loading && metrics.start === 0) {
            // set start time
            setMetrics((state)=>({
                    ...state,
                    type: resource.type,
                    isCacheHit: false,
                    start: invocationTimestamp
                }));
            return;
        }
        if (!slice.loading && metrics.start !== $4b8251d22820126b$var$defaultMetrics.start && metrics.end === $4b8251d22820126b$var$defaultMetrics.end) // set end time
        setMetrics((state)=>({
                ...state,
                duration: invocationTimestamp - state.start,
                end: invocationTimestamp
            }));
    }, [
        currentRoute,
        metrics,
        resource,
        slice
    ]);
    // watch the metrics object and send event when it has enough data
    (0, $eJOHy.useEffect)(()=>{
        const { error: error } = slice;
        if (isSentRef.current || !$4b8251d22820126b$var$canSendMetrics(metrics) || // Always send error events but sample success events (1 in every 10)
        !error && Math.random() * 100 > $4b8251d22820126b$var$SAMPLING_RATE) return;
        const { isCacheHit: isCacheHit, duration: duration, start: start, end: end, type: resourceType } = metrics;
        const action = error ? 'fetchFailed' : 'fetchSucceeded';
        const analyticsEvent = createAnalyticsEvent({
            action: action
        });
        const errorMessage = error && error instanceof Error ? error.toString() : error;
        const routeName = currentRoute.name ? currentRoute.name : 'empty';
        (0, $kRgKj.fireOperationalAnalytics)(analyticsEvent, `${action} resource`, resource.type, {
            duration: duration,
            isCacheHit: isCacheHit,
            start: start,
            end: end,
            routeName: routeName,
            prefetchStartTime: (0, $gNSxk.getPrefetchStartMark)(currentMatch),
            isInitialRender: isInitialRender,
            resourceType: resourceType,
            ...errorMessage !== null && errorMessage !== undefined ? {
                error: errorMessage
            } : {}
        });
        if (error) {
            (0, $9pTd3.fireErrorAnalytics)({
                meta: {
                    id: `spaTransitionResources.${(resourceType || '').toLowerCase()}`,
                    packageName: 'jiraSpaTransitionResourcesTracker',
                    teamName: 'nike'
                },
                attributes: {
                    // Filter out synthetic tests using all known ways
                    isSynthetic: (0, $hWeHP.default)('ajs-is-synthetic') === 'true' || (0, $4cTDP.fg)('forge_ui_synthetic_check')
                },
                error: // @ts-expect-error - TS2322 - Type 'Error | Record<string, any> | (Error & Record<string, any>) | (Record<string, any> & Error)' is not assignable to type 'Error | undefined'.
                error,
                skipSentry: true
            });
            (0, $eSnSE.default).safeErrorWithoutCustomerData(`resources.${(resourceType || '').toLowerCase()}`, // @ts-expect-error - TS2345 - Argument of type 'string | Record<string, any>' is not assignable to parameter of type 'string'.
            errorMessage || '', error);
        }
        // add the resource metrics to the spa state store
        setResourceMetrics({
            end: // @ts-expect-error - TS2322 - Type 'number | null' is not assignable to type 'number'.
            end,
            isCacheHit: // @ts-expect-error - TS2322 - Type 'boolean | null' is not assignable to type 'boolean'.
            isCacheHit,
            start: start,
            // @ts-expect-error - TS2322 - Type 'string | null' is not assignable to type 'string'.
            type: resourceType
        });
        isSentRef.current = true;
    }, [
        createAnalyticsEvent,
        currentRoute,
        metrics,
        setResourceMetrics,
        slice,
        resource,
        currentMatch,
        isInitialRender
    ]);
    return null;
};
const $4b8251d22820126b$export$6779e99be8920b32 = (0, $kfvK2.createRouterSelector)((router)=>router.route);
const $4b8251d22820126b$export$70911e2dbc8f12b6 = (0, $kfvK2.createRouterSelector)((router)=>router.match);
const $4b8251d22820126b$export$b5bbbe33c7801196 = ()=>{
    const currentRoute = $4b8251d22820126b$export$6779e99be8920b32();
    const currentMatch = $4b8251d22820126b$export$70911e2dbc8f12b6();
    const [{ isInitialRender: isInitialRender }] = (0, $3lhVL.useSpaStateTransition)();
    (0, $eJOHy.useEffect)(()=>{
        (0, $gNSxk.clearPrefetchStartMarks)(currentMatch);
    }, [
        currentMatch
    ]);
    const resourcesToTrack = (0, $eJOHy.useMemo)(()=>(0, (/*@__PURE__*/$parcel$interopDefault($jOCpp)))(currentRoute?.resources?.filter((resource)=>resource.type !== (0, $cJYBV.RESOURCE_TYPE_NOOP)), (resource)=>resource.type), [
        currentRoute?.resources
    ]);
    return resourcesToTrack.map((resource)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($4b8251d22820126b$var$ResourceMetricTracker, {
            key: resource.type,
            resource: resource,
            route: currentRoute,
            currentMatch: currentMatch,
            isInitialRender: isInitialRender
        }));
};

});
parcelRegister("gNSxk", function(module, exports) {
$parcel$export(module.exports, "setPrefetchStartMark", () => $7e18a8aa366ad472$export$405fde3eab8e39f6);
$parcel$export(module.exports, "getPrefetchStartMark", () => $7e18a8aa366ad472$export$cbaceb7ffa84279);
$parcel$export(module.exports, "clearPrefetchStartMarks", () => $7e18a8aa366ad472$export$d6b0928f07bafe57);
const $7e18a8aa366ad472$var$prefetchTiming = new Map();
const $7e18a8aa366ad472$export$405fde3eab8e39f6 = (match)=>{
    const currentMatch = JSON.stringify(match);
    if (!$7e18a8aa366ad472$var$prefetchTiming.has(currentMatch)) $7e18a8aa366ad472$var$prefetchTiming.set(currentMatch, {
        startPrefetchTime: Date.now()
    });
};
const $7e18a8aa366ad472$export$cbaceb7ffa84279 = (match)=>{
    const currentMatch = JSON.stringify(match);
    const { startPrefetchTime: startPrefetchTime } = $7e18a8aa366ad472$var$prefetchTiming.get(currentMatch) || {
        startPrefetchTime: null
    };
    return startPrefetchTime;
};
const $7e18a8aa366ad472$export$d6b0928f07bafe57 = (match)=>{
    if (!$7e18a8aa366ad472$var$prefetchTiming || !$7e18a8aa366ad472$var$prefetchTiming.keys) return;
    const currentMatch = JSON.stringify(match);
    const keys = Array.from($7e18a8aa366ad472$var$prefetchTiming.keys());
    keys.forEach((mark)=>{
        if (mark !== currentMatch && $7e18a8aa366ad472$var$prefetchTiming.has(mark)) $7e18a8aa366ad472$var$prefetchTiming.delete(mark);
    });
};

});




//# sourceMappingURL=async-global-trackers-components.64ee172e.js.map
